"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function _default(_ref) {
  var index = _ref.index,
    data = _ref.data,
    classes = _ref.classes,
    onSectionClick = _ref.onSectionClick,
    onItemClick = _ref.onItemClick;
  var items = data.items,
    section = data.section;
  return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null, ' ', index !== 0 ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.operators
  }, " AND ") : '', /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.filterName, classes["facetSection".concat(section, "Background")]),
    onClick: function onClick() {
      return onSectionClick(data);
    }
  }, data.label), ' '), /*#__PURE__*/_react.default.createElement("span", null, ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.operators
  }, "IS BETWEEN", ' '), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.filterCheckboxes, classes["facetSection".concat(section)]),
    onClick: function onClick() {
      return onItemClick(data, items[0]);
    }
  }, "".concat(items[0], " \u2013 ").concat(items[1]))));
};
exports.default = _default;